import React from 'react'
import PropTypes from 'prop-types'
import {Link, useLocation} from "react-router-dom"
import BackToMethodSelectionButton from '../misc/BackToMethodSelectionButton'
import SendCouponEmailButton from './SendCouponEmailButton'
import DownloadCouponButton from './DownloadCouponButton'
import './StartBasicControls.scss'
import {useI18nContext} from "../i18n/I18nContext";
import {getI18nTextWithContext} from "wipi-common/src/lib/i18n";
import goToPostLight from '../../assets/illustrations/go-to-post-office-light.svg';
import goToPostDark from '../../assets/illustrations/go-to-post-office-dark.svg';


export default function StartBasicControls({caseInfo, successIdent, backToBranchUrl, isMobileDevice, couponData, setCouponData}) {
    const context = useI18nContext()
    const location = useLocation()
    const linkDescription = getI18nTextWithContext(context, 'startBasic.openAppCouponBtn')
    const iconDescription = getI18nTextWithContext(context, 'startBasic.openAppCouponBtn')
    const variantsHeading = getI18nTextWithContext(context, 'startBasic.variants.heading')
    const variantsSubHeading = getI18nTextWithContext(context, 'startBasic.variants.subheading')

    return <>
        <p className="variants-heading">
            {variantsHeading}
        </p>
        <p className="variants-subheading">
            {variantsSubHeading}
        </p>
        <div className="row d-flex flex-row py-2">
            <div className="col-xxl-5 col-xl-5 col-sm-12 d-flex align-items-start justify-content-center pb-3">
                <img src={goToPostLight} data-test-id="b1234567-89ab" className="light-img-basic" alt=""/>
                <img src={goToPostDark} data-test-id="b1234567-89ab" className="dark-img-basic" alt=""/>
            </div>
            <div className="col-xxl-7 col-xl-7 align-self-center">

                <div className="d-grid gap-2">
                    <DownloadCouponButton caseId={caseInfo.caseId} hasIdent={successIdent}
                                          couponData={couponData} setCouponData={setCouponData}
                                          backToBranchUrl={backToBranchUrl} search={location.search}/>
                    <SendCouponEmailButton caseId={caseInfo.caseId} search={location.search}/>
                    <Link to={{pathname: "/basic/app", search: location.search}}
                          className="btn btn-secondary btn-block"
                          data-test-id="8ca15ef1-658b"
                    >
                        {linkDescription} &nbsp;
                        <svg className="icon-arrow" width="16" height="16" viewBox="0 0 16 16"
                             xmlns="http://www.w3.org/2000/svg" fill="none"
                             aria-label={iconDescription}>
                            <path id="arrow-right-icon"
                                  d="M0 9H12.17L6.58 14.59L8 16L16 8L8 0L6.59 1.41L12.17 7H0L0 9Z"/>
                        </svg>
                    </Link>
                </div>
            </div>
        </div>
        <hr className="horizontal-row"/>
        <BackToMethodSelectionButton caseInfo={caseInfo} isMobileDevice={isMobileDevice}/>
    </>
}

StartBasicControls.propTypes = {
    caseInfo: PropTypes.object.isRequired,
    successIdent: PropTypes.bool,
    backToBranchUrl: PropTypes.string,
    isMobileDevice: PropTypes.bool.isRequired,
    couponData: PropTypes.object,
    setCouponData: PropTypes.func.isRequired
}